import { useEffect, useMemo, useRef, useState } from 'react';
import './index.scss';
import { getValue } from '@utils/lodash';
import { getLookupAPIs } from './lookup-apis';
import CloseSmallSvgComponent from '@assets/svg-components/close-small';
import { formatText } from '@common/text-helpers';
import { useNavigationData } from '../LeftNavbar/NavigationContext';

const SingleSelectSearchDropdown = (props: any) => {
  const {
    label,
    id,
    value,
    width,
    onChange,
    selectKey,
    data,
    default_currency,
  } = props;

  const inputRef: any = useRef(null);
  const ref: any = useRef(null);
  const userData = useNavigationData();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [inputChange, setInputChange] = useState(false);
  const [info, setinfo] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const lookupApi = props?.lookup_api;
    if (lookupApi !== null && lookupApi !== '') {
      fetchDefaultData();
    }
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [props?.lookup_api]);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    setQuery('');
  }, [props.resetInput]);

  useEffect(() => {
    if (query) {
      setInputChange(true);
    }
  }, [query]);

  useEffect(() => {
    if (getValue(data, `length`, 0) === 1 && !value) {
      const singleOption = data[0];
      handleClickOption(singleOption);
    }
  }, [data]);

  useEffect(() => {
    if (value && getValue(props, `lookup_api`, '')) {
      if (
        !selectedItem ||
        getValue(selectedItem, selectKey || 'id', '') != value
      ) {
        const foundItem = info.find(
          (item) => getValue(item, selectKey || 'id', '') == value,
        );

        if (foundItem) {
          setSelectedItem(foundItem);
        } else if (value) {
          fetchSelectedItemData();
        }
      }
    } else if (!value) {
      setSelectedItem(null);
    }
  }, [value, info]);

  useEffect(() => {
    const initialSelectedItem = getValue(props, `initial_selected_item`, null);

    if (
      initialSelectedItem &&
      value &&
      getValue(initialSelectedItem, selectKey || 'id', '') == value
    ) {
      setSelectedItem(initialSelectedItem);
      setinfo((prevInfo) => {
        const exists = prevInfo.some(
          (item) => getValue(item, selectKey || 'id', '') == value,
        );
        return exists ? prevInfo : [initialSelectedItem, ...prevInfo];
      });
    }
  }, [props.initial_selected_item, value, selectKey]);

  /* -------------------------------------------------------------------------- */
  /*                                     API Section                            */
  /* -------------------------------------------------------------------------- */

  const fetchSelectedItemData = async () => {
    try {
      const resp = await getLookupAPIs(
        getValue(props, `lookup_api`, ''),
        getValue(props, `lookup_id`, '') || value,
        '',
        getValue(props, `lookup_group_name`, ''),
      );

      if (resp && resp.length > 0) {
        // Find the selected item in the response
        const foundItem = resp.find(
          (item) => getValue(item, selectKey || 'id', '') == value,
        );
        console.log(resp, 'respppp', foundItem, props);

        if (foundItem) {
          setSelectedItem(foundItem);
          // Also update info to include this item if it's not already there
          setinfo((prevInfo) => {
            const exists = prevInfo.some(
              (item) => getValue(item, selectKey || 'id', '') == value,
            );
            return exists ? prevInfo : [foundItem, ...prevInfo];
          });
        }
      }
    } catch (error) {
      console.error('Error fetching selected item data:', error);
    }
  };

  const handleFetchData = async (search_text: string) => {
    if (search_text) {
      try {
        setIsLoading(true);
        let resp = await getLookupAPIs(
          getValue(props, `lookup_api`, ''),
          getValue(props, `lookup_id`, ''),
          search_text,
          getValue(props, `lookup_group_name`, ''),
        );

        if (resp) {
          const preservedInfo = selectedItem
            ? resp.some(
                (item) => getValue(item, selectKey || 'id', '') == value,
              )
              ? resp
              : [
                  selectedItem,
                  ...resp.filter(
                    (item) => getValue(item, selectKey || 'id', '') != value,
                  ),
                ]
            : resp;

          setinfo(preservedInfo);
          setIsLoading(false);
        } else {
          setinfo(selectedItem ? [selectedItem] : []);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      fetchDefaultData();
      onChange(null);
    }
  };
  console.log(info, 'iiiiiiiiiiiiiiiiiiiiii');

  const handleFetchDataUponClose = async (search_text: string) => {
    try {
      setIsLoading(true);
      let resp = await getLookupAPIs(
        getValue(props, `lookup_api`, ''),
        '',
        search_text,
        getValue(props, `lookup_group_name`, ''),
      );
      if (resp) {
        const preservedInfo = selectedItem
          ? resp.some((item) => getValue(item, selectKey || 'id', '') == value)
            ? resp
            : [
                selectedItem,
                ...resp.filter(
                  (item) => getValue(item, selectKey || 'id', '') != value,
                ),
              ]
          : resp;

        setinfo(preservedInfo);
        setIsLoading(false);
      } else {
        setinfo(selectedItem ? [selectedItem] : []);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const fetchDefaultData = async () => {
    try {
      setIsLoading(true);
      let resp = await getLookupAPIs(
        getValue(props, `lookup_api`, ''),
        getValue(props, `lookup_id`, ''),
        '',
        getValue(props, `lookup_group_name`, ''),
      );
      if (resp) {
        setinfo(resp);
        if (getValue(resp, `length`, 0) === 1) {
          handleClickOption(getValue(resp, `[${0}]`, {}));
        }
        if (
          getValue(props, `lookup_api`, '').includes('currency') &&
          default_currency &&
          !value
        ) {
          if (userData?.info?.policy?.default_currency) {
            handleClickOption(userData?.info?.policy?.default_currency);
          } else {
            handleClickOption(userData?.info?.org_base_currency);
          }
        }
        setIsLoading(false);
      } else {
        setinfo([]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleClickOption = (option: any) => {
    setSelectedItem(option);
    onChange && onChange(option);
    setInputChange(false);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setSelectedItem(null);
    handleFetchDataUponClose('');
    setQuery('');
    onChange(null);
    inputRef.current.focus();
    setIsOpen(true);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const toggleBox = (e: any) => {
    if (!getValue(props, `disabled`, false)) setIsOpen(!isOpen);
  };
  const toggle = (e: any) => {
    setIsOpen(e && e.target === inputRef.current);
  };
  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    } else {
    }
  };
  /* ---------------------------  API Logics ----------------------------- */
  const filter = (options: any) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option: any) =>
            getValue(option, `[${label}]`, '') &&
            option[label].toLowerCase().indexOf(query.toLowerCase()) > -1,
        )
      : [];
  };

  // Updated to use selectedItem if available
  const findSelectedPipeline = (id: any) => {
    // First check if we have the selected item stored
    if (selectedItem && getValue(selectedItem, selectKey || 'id', '') == id) {
      return getValue(selectedItem, label, '');
    }

    // Fallback to searching in info array
    let list =
      getValue(info, `length`, 0) > 0
        ? info.filter(
            (item) =>
              getValue(item, `[${selectKey ? selectKey : 'id'}]`, '') == id,
          )
        : [];
    return getValue(list, `length`, 0) > 0
      ? getValue(list, `[${0}].${label}`, '')
      : '';
  };

  const valueLabel = useMemo(
    () => findSelectedPipeline(value),
    [value, props.value, selectedItem, getValue(info, `length`, 0) > 0],
  );

  /* ---------------------------  Static Logics ----------------------------- */

  const filter1 = (options: any) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option: any) =>
            getValue(option, `[${label}]`, '') &&
            option[label].toLowerCase().indexOf(query.toLowerCase()) > -1,
        )
      : [];
  };
  const findSelectedValue = (id: any) => {
    let list =
      getValue(data, `length`, 0) > 0
        ? data.filter(
            (item: object) =>
              getValue(item, `[${selectKey ? selectKey : 'id'}]`, '') == id,
          )
        : [];
    return getValue(list, `length`, 0) > 0
      ? getValue(list, `[${0}].label`, '')
      : '';
  };
  const valueLabel1 = useMemo(
    () => findSelectedValue(value),
    [value, data, getValue(data, `length`, 0) > 0],
  );

  return (
    <>
      {getValue(props, `lookup_api`, '') ? (
        <div className={'dropdownselect-form'} ref={ref}>
          {getValue(props, `showLabel`, false) && (
            <label
              className={`${
                getValue(props, 'mandatory', false)
                  ? 'form-label-error'
                  : 'form-label'
              } ${getValue(props, `showReportText`, false) ? 'mb-0' : ''}`}
            >
              {getValue(props, `name`, '')}
              <span className="ms-1">
                {getValue(props, `mandatory`, false) ? '*' : ''}
              </span>
            </label>
          )}

          {getValue(props, `showReportText`, false) ? (
            <>
              <div
                className="small info-text"
                style={{
                  marginBottom: '8px',
                  opacity: '0.5',
                  fontSize: '12px',
                }}
              >
                [Add this expense to a report and submit it to claim
                reimbursement]
              </div>
            </>
          ) : (
            ''
          )}

          <div
            className={`selected-value-box position-relative ${
              isOpen ? 'active' : ''
            } ${props.disabled ? 'disabled' : ''} `}
            onClick={toggleBox}
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `headerWidth`, '')
                : width,
            }}
          >
            <div className="search_container">
              <img src={'/images/search1.svg'} className="search_image" />
              <input
                className="search_input"
                ref={inputRef}
                type="text"
                value={
                  inputChange
                    ? query
                      ? query
                      : valueLabel
                    : valueLabel
                      ? valueLabel
                      : query
                }
                name="searchTerm"
                autoComplete="off"
                placeholder={getValue(
                  props,
                  `placeholder`,
                  'Please Search here...',
                )}
                onChange={(e) => {
                  !getValue(e, `target.value`, '') && onChange(null);
                  setQuery(getValue(e, `target.value`, ''));
                  handleFetchData(getValue(e, `target.value`, ''));
                  setIsOpen(true);
                }}
                onClick={toggleBox}
                disabled={props.disabled}
              />
            </div>
            <div
              className="right_container"
              style={{ background: 'transparent' }}
            >
              {valueLabel && !getValue(props, `disabled`, false) && (
                <div onClick={(e) => handleClose(e)}>
                  <CloseSmallSvgComponent />
                </div>
              )}
              <div className="arrow_image_container">
                <img
                  src={
                    isOpen
                      ? '/dropdown/arrow_up.svg'
                      : '/dropdown/arrow_down.svg'
                  }
                  className="arrow_image"
                />
              </div>
            </div>
          </div>

          {getValue(props, `lookup_api`, '') === 'gl' && (
            <div className="gl-code-field mt-2">
              <label className="form-label">GL Code</label>
              <input
                className="custom-form-control form-control"
                type="text"
                value={getValue(selectedItem, `gl_code`, '')}
                readOnly
                disabled
              />
            </div>
          )}

          <div
            className={`options ss-dd-selected-options-wrap ${
              getValue(props, `lookup_api`, '') === 'gl' ? 'gl-options' : ''
            } ${
              isOpen ? 'open' : ''
            }`}
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `optionsWidth`, '')
                : width,
              zIndex: 1000,
            }}
          >
            <div>
              <div className="option_container">
                {isLoading ? (
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: '10px',
                      marginBottom: '5px',
                    }}
                  >
                    <img
                      src={`/dropdown/loader2.gif`}
                      className="loader"
                      style={{ height: '15px', width: '50px' }}
                    />
                  </div>
                ) : filter(info).length > 0 ? (
                  filter(info).map((option: object, index: number) => {
                    return (
                      <>
                        {getValue(props, `display_name`, '') === 'Trip' ? (
                          <>
                            <div
                              onClick={() => {
                                handleClickOption(option);
                                toggle(null);
                              }}
                              className={`option ${
                                getValue(
                                  option,
                                  `[${selectKey ? selectKey : 'id'}]`,
                                  '',
                                ) == value
                                  ? 'selected'
                                  : ''
                              }`}
                              key={`${id}-${index}`}
                            >
                              <div className="selected_text info-dropdown">
                                <div className="info-dropdown-id">
                                  {getValue(option, `trip_id`, '')}
                                </div>
                                <div className="info-dropdown-name">
                                  {getValue(option, `trip_name`, '')}
                                </div>
                                <div className="info-dropdown-amount">
                                  {formatText(
                                    getValue(option, `travel_type`, ''),
                                  )}
                                </div>
                              </div>
                              {getValue(
                                option,
                                `[${selectKey ? selectKey : 'id'}]`,
                                '',
                              ) == value && (
                                <img
                                  src="/dropdown/done.svg"
                                  className="done_image"
                                />
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              onClick={() => {
                                handleClickOption(option);
                                toggle(null);
                              }}
                              className={`option ${
                                getValue(
                                  option,
                                  `[${selectKey ? selectKey : 'id'}]`,
                                  '',
                                ) == value
                                  ? 'selected'
                                  : ''
                              }`}
                              key={`${id}-${index}`}
                            >
                              <div className="selected_text">
                                {getValue(option, `[${label}]`, '')}
                              </div>
                              {getValue(
                                option,
                                `[${selectKey ? selectKey : 'id'}]`,
                                '',
                              ) == value && (
                                <img
                                  src="/dropdown/done.svg"
                                  className="done_image"
                                />
                              )}
                            </div>
                          </>
                        )}
                      </>
                    );
                  })
                ) : (
                  <div className="nodata">No Info Found</div>
                )}
              </div>
            </div>
            {getValue(props, `add`, '') ? (
              <div className="button_container">
                <img src={'/dropdown/add.svg'} className="button_image" />
                <p className="button_input">Add Button</p>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className={'dropdownselect-form'} ref={ref}>
          {getValue(props, `showLabel`, false) && (
            <label
              className={`${
                getValue(props, 'mandatory', false)
                  ? 'form-label-error'
                  : 'form-label'
              } ${getValue(props, `showReportText`, false) ? 'mb-0' : ''}`}
            >
              {getValue(props, `name`, '')}
              <span className="ms-1">
                {getValue(props, `mandatory`, false) ? '*' : ''}
              </span>
            </label>
          )}
          {getValue(props, `showReportText`, false) ? (
            <>
              <div
                className="small info-text"
                style={{
                  marginBottom: '8px',
                  opacity: '0.5',
                  fontSize: '12px',
                }}
              >
                [Add this expense to a report and submit it to claim
                reimbursement]
              </div>
            </>
          ) : (
            ''
          )}
          <div
            className={`selected-value-box position-relative ${
              isOpen ? 'active' : ''
            } ${props.disabled ? 'disabled' : ''} `}
            onClick={toggleBox}
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `headerWidth`, '')
                : width,
            }}
          >
            <div className="search_container">
              <img src={'/images/search1.svg'} className="search_image" />
              <input
                className="search_input"
                ref={inputRef}
                type="text"
                value={
                  inputChange
                    ? query
                      ? query
                      : valueLabel1
                    : valueLabel1
                      ? valueLabel1
                      : query
                }
                name="searchTerm"
                autoComplete="off"
                placeholder={getValue(
                  props,
                  `placeholder`,
                  'Please Search here...',
                )}
                onChange={(e) => {
                  !e.target.value && onChange(null);
                  setQuery(e.target.value);
                }}
                onClick={toggleBox}
                style={{
                  minWidth: getValue(props, `customStyle`, false) && '50px',
                  background: props.disabled ? '#e9ecef' : '',
                }}
                disabled={props.disabled}
              />
            </div>
            <div
              className="right_container"
              style={{ background: 'transparent' }}
            >
              {valueLabel1 && !getValue(props, `disabled`, false) && (
                <div onClick={(e) => handleClose(e)}>
                  <CloseSmallSvgComponent />
                </div>
              )}
              <div className="arrow_image_container">
                <img
                  src={
                    isOpen
                      ? '/dropdown/arrow_up.svg'
                      : '/dropdown/arrow_down.svg'
                  }
                  className="arrow_image"
                />
              </div>
            </div>
          </div>

          <div
            className={`options ${isOpen ? 'open' : ''}`}
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `optionsWidth`, '')
                : width,
            }}
          >
            <div>
              <div className="option_container">
                {filter1(data).length > 0 ? (
                  filter1(data).map((option: object, index: number) => {
                    return (
                      <div
                        onClick={() => {
                          handleClickOption(option);
                          toggle(null);
                        }}
                        className={`option ${
                          getValue(
                            option,
                            `[${selectKey ? selectKey : 'id'}]`,
                            '',
                          ) == value
                            ? 'selected'
                            : ''
                        }`}
                        key={`${id}-${index}`}
                      >
                        <div className="selected_text">
                          {getValue(option, `[${label}]`, '')}
                        </div>
                        {getValue(
                          option,
                          `[${selectKey ? selectKey : 'id'}]`,
                          '',
                        ) == value && (
                          <img
                            src="/dropdown/done.svg"
                            className="done_image"
                          />
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="nodata">No Data Found</div>
                )}
              </div>
            </div>
            {getValue(props, `add`, '') ? (
              <div
                className="button_container single-search-button-container"
                onClick={props.onClickAdd}
              >
                <img src={'/dropdown/add.svg'} className="button_image" />
                <p className="button_input">
                  {getValue(props, `showReportText`, false)
                    ? 'Create new report'
                    : 'Add Button'}{' '}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      )}
      {props.validator && (
        <span className="form-error">
          {props.validator.current.message(
            getValue(props, `name`, ''),
            props.value,
            'required',
          )}
        </span>
      )}
    </>
  );
};

export default SingleSelectSearchDropdown;
